import React, { useState } from 'react';
import styled from 'styled-components';

const ITEMS = [
    { name: 'Shortcut to bonzibuddy.exe', type: 'Application', size: '2.4 MB', deleted: '14/03/2024 09:32' },
    { name: 'FREE_SCREENSAVER.exe', type: 'Application', size: '847 KB', deleted: '22/06/2023 14:15' },
    { name: 'norton_antivirus_crack.zip', type: 'ZIP Archive', size: '12.1 MB', deleted: '08/11/2023 11:44' },
    { name: 'definitely-not-a-virus.bat', type: 'Batch File', size: '1 KB', deleted: '01/02/2024 16:28' },
    { name: 'Toolbar_installer_v3.exe', type: 'Application', size: '3.7 MB', deleted: '19/04/2023 10:02' },
    { name: 'Annual_Review_2023.doc', type: 'Word Document', size: '156 KB', deleted: '30/12/2023 17:45' },
    { name: 'backup_passwords_FINAL.txt', type: 'Text Document', size: '2 KB', deleted: '15/01/2024 08:55' },
    { name: 'client_database.accdb', type: 'Access Database', size: '48.3 MB', deleted: '28/02/2024 13:12' },
    { name: 'Windows_Genuine_Advantage.exe', type: 'Application', size: '892 KB', deleted: '11/07/2023 09:30' },
];

function RecycleBin() {
    const [selectedIdx, setSelectedIdx] = useState(-1);
    const [items, setItems] = useState(ITEMS);
    const [showDialog, setShowDialog] = useState(false);

    function emptyBin() {
        setShowDialog(true);
    }

    function confirmEmpty() {
        setItems([]);
        setShowDialog(false);
        setSelectedIdx(-1);
    }

    return (
        <Container>
            <div className="rb__toolbar">
                <div className="rb__toolbar__title">Recycle Bin</div>
                <div className="rb__toolbar__actions">
                    <button className="rb__btn" onClick={emptyBin} disabled={items.length === 0}>
                        Empty Recycle Bin
                    </button>
                    <button className="rb__btn" disabled>Restore All Items</button>
                </div>
            </div>
            <div className="rb__sidebar">
                <div className="rb__sidebar__section">
                    <div className="rb__sidebar__title">Recycle Bin Tasks</div>
                    <div className="rb__sidebar__link" onClick={emptyBin}>Empty the Recycle Bin</div>
                </div>
                <div className="rb__sidebar__section">
                    <div className="rb__sidebar__title">System Info</div>
                    <div className="rb__sidebar__info">{items.length} item(s)</div>
                    <div className="rb__sidebar__info">
                        {items.length > 0 ? 'Contains suspicious files' : 'Bin is empty'}
                    </div>
                </div>
                {items.length > 0 && (
                    <div className="rb__sidebar__section">
                        <div className="rb__sidebar__title">Security Notice</div>
                        <div className="rb__sidebar__warning">
                            ⚠ Several items appear to be malware. Consider calling Dead Simple Computing on <strong>0118 359 2220</strong> for a proper cleanup.
                        </div>
                    </div>
                )}
            </div>
            <div className="rb__content">
                <div className="rb__header__row">
                    <span className="rb__col rb__col--name">Name</span>
                    <span className="rb__col rb__col--type">Type</span>
                    <span className="rb__col rb__col--size">Size</span>
                    <span className="rb__col rb__col--date">Date Deleted</span>
                </div>
                <div className="rb__list">
                    {items.length === 0 && (
                        <div className="rb__empty">Recycle Bin is empty</div>
                    )}
                    {items.map((item, i) => (
                        <div
                            key={item.name}
                            className={`rb__item ${selectedIdx === i ? 'rb__item--selected' : ''}`}
                            onClick={() => setSelectedIdx(i)}
                        >
                            <span className="rb__col rb__col--name">
                                <span className="rb__icon">🗑️</span>
                                {item.name}
                            </span>
                            <span className="rb__col rb__col--type">{item.type}</span>
                            <span className="rb__col rb__col--size">{item.size}</span>
                            <span className="rb__col rb__col--date">{item.deleted}</span>
                        </div>
                    ))}
                </div>
            </div>
            {showDialog && (
                <div className="rb__dialog__overlay">
                    <div className="rb__dialog">
                        <div className="rb__dialog__header">Confirm Multiple File Delete</div>
                        <div className="rb__dialog__body">
                            <div className="rb__dialog__icon">⚠️</div>
                            <div>
                                <p>Are you sure you want to permanently delete these {items.length} items?</p>
                                <p className="rb__dialog__warning">Warning: Some of these files look like malware. Honestly, you're doing yourself a favour.</p>
                            </div>
                        </div>
                        <div className="rb__dialog__buttons">
                            <button className="rb__xp__btn" onClick={confirmEmpty}>Yes</button>
                            <button className="rb__xp__btn" onClick={() => setShowDialog(false)}>No</button>
                        </div>
                    </div>
                </div>
            )}
        </Container>
    );
}

const Container = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #fff;
  font-family: Tahoma, sans-serif;
  font-size: 11px;
  position: relative;

  .rb__toolbar {
    background: linear-gradient(to right, #2955a5, #5b8dde);
    padding: 8px 12px;
    color: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .rb__toolbar__title { font-size: 16px; font-weight: bold; }
  .rb__toolbar__actions { display: flex; gap: 4px; }
  .rb__btn {
    padding: 3px 10px;
    background: linear-gradient(to bottom, #fff, #e3e3e3);
    border: 1px solid #999;
    font-family: Tahoma, sans-serif;
    font-size: 10px;
    cursor: pointer;
    color: #333;
    &:hover:not(:disabled) { background: linear-gradient(to bottom, #e3e3e3, #fff); }
    &:disabled { opacity: 0.5; cursor: default; }
  }

  .rb__sidebar {
    display: none;
  }

  @media (min-width: 500px) {
    flex-direction: row;
    flex-wrap: wrap;
    .rb__toolbar { flex-basis: 100%; }
    .rb__sidebar {
      display: block;
      width: 160px;
      background: #dfe8f6;
      border-right: 1px solid #7f9db9;
      padding: 8px;
      overflow-y: auto;
    }
    .rb__content { flex: 1; }
  }

  .rb__sidebar__section {
    margin-bottom: 12px;
  }
  .rb__sidebar__title {
    font-weight: bold;
    color: #003399;
    font-size: 11px;
    margin-bottom: 4px;
    border-bottom: 1px solid #7f9db9;
    padding-bottom: 2px;
  }
  .rb__sidebar__link {
    color: #003399;
    cursor: pointer;
    padding: 2px 0;
    &:hover { text-decoration: underline; }
  }
  .rb__sidebar__info {
    color: #333;
    padding: 1px 0;
    font-size: 10px;
  }
  .rb__sidebar__warning {
    color: #cc0000;
    font-size: 10px;
    line-height: 1.4;
    margin-top: 4px;
    strong { color: #003399; }
  }

  .rb__content {
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }
  .rb__header__row {
    display: flex;
    background: linear-gradient(to bottom, #fff, #e8e8e8);
    border-bottom: 1px solid #999;
    font-weight: bold;
    color: #333;
  }
  .rb__col {
    padding: 3px 8px;
    border-right: 1px solid #ddd;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .rb__col--name { flex: 2; min-width: 150px; }
  .rb__col--type { flex: 1; min-width: 80px; }
  .rb__col--size { width: 70px; text-align: right; }
  .rb__col--date { width: 120px; }
  .rb__list {
    flex: 1;
    overflow-y: auto;
  }
  .rb__item {
    display: flex;
    cursor: pointer;
    &:hover { background: #e8f0ff; }
    &--selected { background: #316ac5; color: #fff; }
  }
  .rb__icon { margin-right: 4px; }
  .rb__empty {
    padding: 40px;
    text-align: center;
    color: #999;
    font-size: 14px;
  }

  .rb__dialog__overlay {
    position: absolute;
    inset: 0;
    background: rgba(0,0,0,0.3);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10;
  }
  .rb__dialog {
    background: #ece9d8;
    border: 2px solid #0054e3;
    box-shadow: 3px 3px 8px rgba(0,0,0,0.3);
    width: 380px;
    max-width: 95%;
  }
  .rb__dialog__header {
    background: linear-gradient(to right, #0054e3, #2e8bff);
    color: white;
    padding: 4px 8px;
    font-weight: bold;
  }
  .rb__dialog__body {
    padding: 16px;
    display: flex;
    gap: 10px;
    line-height: 1.5;
    p { margin: 0 0 6px; }
  }
  .rb__dialog__icon { font-size: 24px; flex-shrink: 0; }
  .rb__dialog__warning { color: #666; font-style: italic; font-size: 10px; }
  .rb__dialog__buttons {
    padding: 8px 16px 12px;
    display: flex;
    justify-content: center;
    gap: 8px;
  }
  .rb__xp__btn {
    padding: 4px 18px;
    background: linear-gradient(to bottom, #fff, #e3e3e3);
    border: 1px solid #999;
    border-radius: 2px;
    cursor: pointer;
    font-family: Tahoma, sans-serif;
    font-size: 11px;
    &:hover { background: linear-gradient(to bottom, #e3e3e3, #fff); }
    &:active { background: #ccc; }
  }
`;

export default RecycleBin;
